export interface MenuButtonItem {
    id: string;
    path?: string;
    name?: string;
    command?: (e: MenuButtonItem) => void;
    label: string;
    icon?: string;
    ignoreSecurity?: boolean;
    description?: string;
    disabled?: boolean;
    order?: number;
    testId?: string;
}

export const sortMenuButtonItems = (a: MenuButtonItem, b: MenuButtonItem) => {

    if (a.order !== undefined && b.order !== undefined) {
        // Order 0 always first
        if (a.order === 0 && b.order !== 0) return -1;
        if (b.order === 0 && a.order !== 0) return 1;
        return a.order - b.order;
    }
    // If only one has order defined, it comes first
    if (a.order !== undefined) return -1;
    if (b.order !== undefined) return 1;
    // Otherwise, sort by label
    return a.label.localeCompare(b.label);

}

